module.exports = __webpack_public_path__ + "static/media/WBTCe.7c448f4b.svg";